enum DueIstance {
    ATHENASPA = "ATHENASPA",
    AMI = "AMI"
}

export default DueIstance;